module.exports = __webpack_public_path__ + "static/preview-bslgov-c64ba99a7872edb66d52406eb4c78fcf.png";